import { useBackendData } from 'services/useBackendData';

import { itemService } from './itemService';

export const useItemData = (itemId?: number) => useBackendData(itemService.fetchItemDetails, itemId);
